import { useQuery } from '@apollo/client'
import { y00tsHoldDuration } from 'apollo/client'
import gql from 'graphql-tag'
import { useMemo } from 'react'
import { notEmpty } from 'utils'

export const QUERY_Y00TS_STATS = gql`
  query records {
    records {
        bin,
        count_wallets
    }
  }
`

interface y00tsStatsData {
    records: {
        bin: String,
        count_wallets: Number,
    }[]
}

/**
 * Fetch matic current price
 */

export function useZettaHoldDuration(): {
    loading: boolean
    error: boolean,
    records: {
        bin: String,
        count_wallets: Number,
    }[] | undefined
} {
    const { loading, error, data } = useQuery<y00tsStatsData>(QUERY_Y00TS_STATS, {
        client: y00tsHoldDuration,
        fetchPolicy: 'cache-first',
    })
    const formattedData = useMemo(() => {
        if (data) {
            return data.records
                .map((p) => {
                    return {
                        bin: p.bin,
                        count_wallets: p.count_wallets,
                    }
                })
                .filter(notEmpty)
        } else {
            return undefined
        }
    }, [data])

    return {
        loading: loading,
        error: Boolean(error),
        records: formattedData,
    }
}
